import { render, staticRenderFns } from "./FinalizacaoAnexosExcluir.vue?vue&type=template&id=241145fe"
import script from "./FinalizacaoAnexosExcluir.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAnexosExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports